/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
//const TEST = `https://d11-api-backend-java-test-dt.io.mlj130.com`;
const TEST = `https://d11-admin-backend-java-test-dt.io.mlj130.com`;
const PRODUCTION = `https://d11-admin-backend-java.io.mlj130.com`;
// BaseUrl="https://d11-admin-backend-java.io.mlj130.com";
// BaseUrl="https://d11-admin-backend-java-test-dt.io.mlj130.com";
const DOMAIN = process.env.PREACT_APP_ENV === "development" ? TEST : PRODUCTION;
const TEST_CJS = `https://cjs-api-backend-java-test-dt.io.mlj130.com`;
const PRODUCTION_CJS = `https://cjs-api-backend-java.io.mlj130.com`;
const DOMAIN_CJS = process.env.PREACT_APP_ENV === "development" ? TEST_CJS : PRODUCTION_CJS;
const TEST_LIVE=`/lt`;
const PRODUCTION_LIVE_PROD=`https://secret-list.io.mlj130.com/lt`;
const PRODUCTION_LIVE_TEST=`https://secret-list-test-dt.io.mlj130.com/lt`;
const PRODUCTION_LIVE = process.env.PREACT_APP_ENV === "development" ? PRODUCTION_LIVE_TEST:PRODUCTION_LIVE_PROD;
//const PRODUCTION_LIVE=`http://172.21.8.231/lt`;
console.log( process.env.PREACT_APP_ENV , '================================================');
const DOMAIN_LIVE = process.env.PREACT_APP_ENV === "development" ? PRODUCTION_LIVE_TEST : PRODUCTION_LIVE;
const WECOM_DEV = `https://shequnkit-test-dt.io.mlj130.com`;
const WECOM_PROD = `https://shequnkit.io.mlj130.com`;
const WECOM_URL= process.env.PREACT_APP_ENV === "development" ?WECOM_DEV:WECOM_PROD;

const CommunityCollectLink = 'https://cdn.mlj122.com'
import JD from "@images/jd.png";
import TB from "@images/tb.png";
import PDD from "@images/pdd.png";
import { isAndroid } from "./utils";
const liveTypeList = [
    {
        label: "今日直播",
        value: "1"
    },
    {
        label: "直播预告",
        value: "0"
    },
    {
        label: "历史直播",
        value: "2"
    }];
const liveTypeNameList = {
    0: "直播预告",
    1: "今日直播",
    2: "历史直播"
};
const platform = {
    3: "淘宝",
    4: "京东",
    6: "拼多多",
    7: "抖音"
}
const linkList = {
    3: "taobao",
    4: "jd",
    6: "pdd",
    7: "抖音"
}
const IconList = {
    3: TB,
    4: JD,
    6: PDD,
}
const handleLink = (type, link) => {
    if (type == "3") {
        return link.replace("https", `${linkList[type]}`);
    } else if (type == "4") {
        const jsonObj = { des: "getCoupon", category: "jump", url: link }
        return `openApp.jdMobile://virtual?params=${decodeURI(JSON.stringify(jsonObj))}`
    }
    return link

}
const jumpHandle = (urlScheme, link) => {
    let visible = true;
    let timeout = null;
    let startTime = 0;
    const handle = () => {
        if (document.visibilityState === "hidden") {
            startTime = new Date().getTime();
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            visible = false;
        }
        if (document.visibilityState === "visible") {
            document.removeEventListener("visibilitychange", handle);
            if ((new Date().getTime() - startTime) < 300 && isAndroid()) {
                window.location.href = link;
            }
            visible = false;
        }
    }
    document.addEventListener("visibilitychange", handle);
    const iframe = document.createElement("iframe");
    iframe.style.visibility = "hidden";
    iframe.style.width = 0;
    iframe.style.height = 0;
    iframe.src = urlScheme;
    iframe.onerror = () => (window.location.href = link);
    document.body.appendChild(iframe);
    timeout = setTimeout(() => {
        if (visible) window.location.href = link;
    }, 2000);
}
//价格调整
 const bornSmallNumber=(num)=>{
    const lastNum=Number(((Number(num)*100)%100).toFixed(0));
    if(lastNum==0){
      return ".00"
    }else if(lastNum>9){
      return `.${lastNum}`
    }else{
      return `.0${lastNum}`
    }
  }
const bornCouponPrice=(num)=>{
    num=Math.abs(num)
    const firstNum=parseInt(num);
    let lastNum=Number(((Number(num)*100)%100).toFixed(0));
    if(lastNum==0){
      lastNum= ".00"
    }else if(lastNum>9){
      lastNum= `.${lastNum}`
    }else{
      lastNum =`.0${lastNum}`
    }
    return `${firstNum}${lastNum}`
  }
export {WECOM_URL, DOMAIN,DOMAIN_CJS, DOMAIN_LIVE,CommunityCollectLink,liveTypeList, platform, handleLink, jumpHandle, liveTypeNameList, IconList,bornSmallNumber,bornCouponPrice };
